import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import {
  UPDATE_NOTE_FAILURE,
  UPDATE_NOTE_REQUEST,
  UPDATE_NOTE_SUCCESS
} from "../types";
import { addEntities } from "../../entities";

export default (noteId, note, attachment) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(UPDATE_NOTE_REQUEST)({}));
    const response = await api.debtors.updateNote(noteId, note, attachment);
    const data = normalize(response, schema.notes);
    dispatch(addEntities(data.entities));
    dispatch(createAction(UPDATE_NOTE_SUCCESS)({}));
    return response;
  } catch (err) {
    dispatch(createAction(UPDATE_NOTE_FAILURE)(err));
    throw err;
  }
};
